<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          id="vxmlName"
          v-model="node.name"
          label="Name"
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
        <div
          v-for="(route, index) in property.routes"
          :key="index"
          class="m-t-10"
        >
          <div class="d-flex justify-space-between width100">
            <div class="d-flex align-start width100">
              <span class="width80px m-t-5">Route {{ index + 1 }}</span>
              <div v-if="index < property.routes.length - 1">
                <v-text-field
                  class="margin0 padding0 width70px"
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  v-model="route.probability"
                  @blur="setPropertyData(index)"
                  hide-details
                  dense
                  reverse
                ></v-text-field>
              </div>
              <div v-else class="width70px text-right m-t-5 p-r-15">
                {{ route.probability }}
              </div>
              <span class="m-t-5">% probability</span>
            </div>

            <v-icon
              v-if="index < property.routes.length - 1"
              small
              class="m-t-10 m-l-10"
              @click="deleteRoute(index)"
            >
              fa-times-circle
            </v-icon>
          </div>
        </div>
      </v-col>
    </v-row>
    <div v-if="property.routes.length < max" class="d-flex">
      <v-icon class="p-r-5" small @click="addRoute()">
        fa-plus-circle
      </v-icon>
      <div class="cursor-pointer" @click="addRoute()">
        Add route
      </div>
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'
import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    drawFlowItems: Object
  },
  components: {
    NoteComponent
  },
  data() {
    return {
      property: {},
      // min: 1,
      max: 10
    }
  },
  created() {
    this.property = this.node.property
  },
  methods: {
    addRoute() {
      if (this.property.routes.length < this.max)
        this.property.routes.push({
          probability: 0
        })
    },
    deleteRoute(index) {
      this.property.routes[index].probability = 0
      this.setPropertyData(index)
      this.property.routes.splice(index, 1)
    },
    setPropertyData(index) {
      let val = this.property.routes[index].probability

      if (val < 0) {
        val = 0
      }

      this.property.routes[index].probability = Math.round(val)

      const sumAll = _.sumBy(this.property.routes, o => o.probability)
      const lastValue = this.property.routes[this.property.routes.length - 1]
        .probability

      if (sumAll > 100) {
        const valueCanUse =
          100 - (sumAll - this.property.routes[index].probability - lastValue)

        if (this.property.routes[index].probability >= valueCanUse) {
          this.property.routes[index].probability = valueCanUse
          this.property.routes[this.property.routes.length - 1].probability = 0
        } else {
          this.property.routes[this.property.routes.length - 1].probability =
            valueCanUse - this.property.routes[index].probability
        }
      } else {
        this.property.routes[this.property.routes.length - 1].probability =
          100 - (sumAll - lastValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.body-dialog {
  margin: 10px !important;
}
.text-condition {
  width: 20px;
  text-align: center;
}

.width70px {
  width: 70px !important;
}
.width100px {
  width: 80px !important;
}
</style>
